import React from 'react';
import ReactPlayer, { ReactPlayerProps } from 'react-player/lazy';

// @ts-ignore
export default ReactPlayer as React.FC<ReactPlayerProps>;
